import { ErrorSVG } from "./svg";

export const CustomQuoteCopy = () => {
  return (
    <p className="px-2 md:px-8 w-full md:w-4/5 mx-auto pb-8 text-center text-sm">
      <ErrorSVG className="stroke-light-purple mb-2" />
      <br />
      Your package is very heavy/large - please check that your stated
      dimensions are correct or contact our customer service by{" "}
      <a
        href="https://wa.me/6591187971"
        className="text-dark-purple hover:text-light-purple"
        target="_blank"
        rel="noopener noreferrer"
        tabIndex={-1}
      >
        WhatsApp
      </a>{" "}
      for a custom quote.
    </p>
  );
};
